import './sass/footer.scss';
import { motion } from "framer-motion";
import { getSectionAnimation } from '../animations/sections';
import { GitHub, Instagram, LinkedIn, Twitter } from '@material-ui/icons';

function Social() {
  return (
    <>
      <motion.div className="fbl" {...getSectionAnimation}>
        <a href="https://github.com/aryamanz29">
          <GitHub />
        </a>
        <a href="https://www.linkedin.com/in/aryamanz29">
          <LinkedIn />
        </a>
        <a href="https://twitter.com/aryamanz29">
          <Twitter />
        </a>
        <a href="https://www.instagram.com/aryaman_z29">
          <Instagram />
        </a>
        <div className="vl"></div>
      </motion.div>
      <motion.div className="fbr" {...getSectionAnimation}>
        <a href={'mailto:aryamanz29@gmail.com'}>aryamanz29@gmail.com</a>
        <div className="vl"></div>
      </motion.div>
    </>
  );
}
export default Social;
